import { generateTypes } from '../../utils/HttpReducerHelper';

const createBusiness = generateTypes('MONITOR_ADD_NEW_WIZZARD', 'CREATE');
const searchCompany = generateTypes('MONITOR_ADD_NEW_WIZZARD', 'SEARCH');
const createBusinessEntities = generateTypes('MONITOR_ADD_NEW_WIZZARD', 'ENTITIES');

const CLEAR_COMPANIES = 'platfi-ui-app/MONITOR_ADD_NEW_WIZZARD/CLEAR_COMPANIES';
const SEND_REPORT = 'platfi-ui-app/MONITOR_ADD_NEW_WIZZARD/SEND_REPORT';
const DOWNLOAD_CREDIT_REPORT_PDF =
  'platfi-ui-app/MONITOR_ADD_NEW_WIZZARD/DOWNLOAD_CREDIT_REPORT_PDF';

export {
  createBusiness,
  createBusinessEntities,
  searchCompany,
  CLEAR_COMPANIES,
  SEND_REPORT,
  DOWNLOAD_CREDIT_REPORT_PDF,
};
